import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Popover,
  Button,
  Paper,
  Container,
  FormControl,
  CssBaseline,
  TextField,
  Grid,
  Tooltip,
} from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import { USER_ROLE } from "../../components/security/UserRole";
import MultipleSelect from "../../components/ui/MultipleSelect";
import { AppConstants } from "../../components/constants/ApplicationConstants";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

const AppointmentHistoryFilter = (props) => {
  const classes = useStyles();
  const user = useSelector((state) => state.authentication.user);
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    if (!Boolean(anchorEl)) {
      setAnchorEl(event.currentTarget);
    }
    // if(props.filterPayload && props.filterPayload.startDateTime){
    //   setStartDateTime(props.filterPayload.startDateTime);
    // }
    // if(props.filterPayload && props.filterPayload.endDateTime){
    //   setEndDateTime(props.filterPayload.endDateTime);
    // }
    // if(props.filterPayload && props.filterPayload.status){
    //   setStatus(props.filterPayload.status);
    // }
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const getOptions = (options) => {
    let result = [];
    for (let i = 0; i < options.length; i++) {
      result.push({
        name:
          (options[i].firstName ? options[i].firstName : "") +
          " " +
          (options[i].lastName ? options[i].lastName : ""),
        id: options[i].id,
      });
    }
    return result;
  };
  const id = open ? "simple-popover" : undefined;
  const [startDateTime, setStartDateTime] = React.useState("");
  const [endDateTime, setEndDateTime] = React.useState("");
  const [status, setStatus] = React.useState([]);
  const [patient, setPatient] = React.useState([]);
  const [doctor, setDoctor] = React.useState([]);
  const [consultationType, setConsultationType] = React.useState([]);
  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <Box p={1}>
          <Tooltip title="Appointment filter" arrow>
            <FilterListIcon
              aria-describedby={id}
              className="ri-filter-fill"
              color="primary"
              onClick={handleClick}
            />
          </Tooltip>
        </Box>
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box clone pt={2} pr={1} pb={1} pl={1}>
          <Paper elevation={0}>
            <Container maxWidth="md">
              <CssBaseline />

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormControl variant="outlined" style={{ width: "100%" }}>
                    <TextField
                      id="startDateTime"
                      name="startDateTime"
                      label="From"
                      type="datetime-local"
                      className={classes.textField}
                      value={startDateTime}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) => {
                        setStartDateTime(event.target.value);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl variant="outlined" style={{ width: "100%" }}>
                    <TextField
                      id="endDateTime"
                      name="endDateTime"
                      label="To"
                      type="datetime-local"
                      className={classes.textField}
                      value={endDateTime}
                      han
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) => {
                        setEndDateTime(event.target.value);
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <MultipleSelect
                    options={AppConstants.APPOINTMENT_STATUS_LIST}
                    label={"Appointment status"}
                    handleInputChange={(value) => {
                      setStatus(value);
                    }}
                    value={status}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <MultipleSelect
                    options={AppConstants.SPECIALITIES_LIST}
                    label={"Consultation type"}
                    handleInputChange={(value) => {
                      setConsultationType(value);
                    }}
                    value={consultationType}
                  />
                </Grid>

                {props.allDoctorList.length > 0 ? (
                  <Grid item xs={12} sm={6}>
                    <MultipleSelect
                      options={getOptions(props.allDoctorList)}
                      label={"Doctor name"}
                      handleInputChange={(value) => {
                        setDoctor(value);
                      }}
                      value={doctor}
                    />
                  </Grid>
                ) : null}
                {props.allPatientList.length > 0 ? (
                  <Grid item xs={12} sm={6}>
                    <MultipleSelect
                      options={getOptions(props.allPatientList)}
                      label={"Patient name"}
                      handleInputChange={(value) => {
                        setPatient(value);
                      }}
                      value={patient}
                    />
                  </Grid>
                ) : null}
              </Grid>
            </Container>

            <Grid container justify="flex-end" spacing={1}>
              <Grid item>
                <Button
                  color="primary"
                  onClick={() => {
                    var payload = {
                      id: "",
                      startDateTime: startDateTime,
                      endDateTime: endDateTime,
                      status: status,
                      patientId:
                        user.userRole === USER_ROLE.PATIENT
                          ? [user.patientId]
                          : patient,
                      doctorId:
                        user.userRole === USER_ROLE.DOCTOR
                          ? [user.doctorId]
                          : doctor,
                      consultationType: consultationType,
                    };
                    handleClose();
                    props.handleFilter(payload);
                  }}
                >
                  Filter
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="secondary"
                  onClick={() => {
                    var payload = {
                      id: "",
                      startDateTime: "",
                      endDateTime: "",
                      status: [],
                      patientId:
                        user.userRole === USER_ROLE.PATIENT
                          ? [user.patientId]
                          : [],
                      doctorId:
                        user.userRole === USER_ROLE.DOCTOR
                          ? [user.doctorId]
                          : [],
                      consultationType: [],
                    };
                    setStartDateTime("");
                    setEndDateTime("");
                    setStatus([]);
                    setPatient([]);
                    setDoctor([]);
                    setConsultationType([]);
                    handleClose();
                    props.handleFilter(payload);
                  }}
                >
                  Clear
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Popover>
    </>
  );
};

export default AppointmentHistoryFilter;
